import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export const Lightbox = ({ item, onClose }) => {
    useEffect(() => {
        if (!item) return;
        const onKey = (e) => e.key === "Escape" && onClose();
        window.addEventListener("keydown", onKey);
        document.body.style.overflow = "hidden";
        if (window.__lenis) window.__lenis.stop();
        return () => {
            window.removeEventListener("keydown", onKey);
            document.body.style.overflow = "";
            if (window.__lenis) window.__lenis.start();
        };
    }, [item, onClose]);

    return (
        <AnimatePresence>
            {item && (
                <motion.div
                    data-testid="image-lightbox-modal"
                    role="dialog"
                    aria-modal="true"
                    aria-label={`${item.title} concept visual, enlarged`}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.25 }}
                    className="fixed inset-0 z-[100] flex items-center justify-center bg-[#0D0C0B]/95 p-4 sm:p-10"
                    onClick={onClose}
                >
                    <motion.img
                        src={item.img}
                        alt={item.alt}
                        initial={{ scale: 0.96, opacity: 0 }}
                        animate={{ scale: 1, opacity: 1 }}
                        exit={{ scale: 0.97, opacity: 0 }}
                        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                        className="frame max-h-[88vh] max-w-full rounded-sm object-contain"
                        onClick={(e) => e.stopPropagation()}
                    />
                    <button
                        type="button"
                        data-testid="lightbox-close-btn"
                        onClick={onClose}
                        aria-label="Close enlarged image"
                        className="font-mono2 absolute right-5 top-5 rounded-full border border-[#262422] bg-[#141312] px-4 py-2 text-xs uppercase tracking-[0.16em] text-[#F4F1EC] transition-colors hover:border-[#C7B7FF]"
                    >
                        Close ✕
                    </button>
                </motion.div>
            )}
        </AnimatePresence>
    );
};
